import React from "react";
import {
  faExclamationTriangle,
  faInfoCircle,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Link } from "react-router-dom";
import { usCurrency } from "../../../utils";

const LoanDisclaimer = ({
  loanData,
  loanStatus,
  isModified,
  setModifyFor,
  showClose,
  setShowClose,
  setSliderOpen2,
}) => {
  return (
    (["Suspended", "InProgress", null].includes(loanStatus) || isModified) && (
      <div
        className={`${
          loanStatus != "Suspended"
            ? "loan-info-card"
            : "loan-info-card-suspension"
        } d-flex`}
      >
        <FontAwesomeIcon
          icon={
            loanStatus != "Suspended" ? faInfoCircle : faExclamationTriangle
          }
          style={{ marginTop: "2px", marginRight: "10px" }}
        />
        <p
          style={{
            marginBottom: "0px",
            fontSize: "14px",
            fontWeight: "400",
          }}
        >
          {["InProgress", null].includes(loanStatus) ? (
            <>
              Below is a summary of your loan request application. Please review
              prior to submitting the request.
            </>
          ) : loanStatus == "Suspended" ? (
            <>
              This {loanData?.loanType ?? "General purpose"} loan ID :{" "}
              {loanData?.loanIdentifier ?? "L001"} is under suspension at
              interest rate {loanData?.loanSuspension?.suspensionInterestRate}%.
              {setModifyFor("suspend")}
              <Link
                onClick={() => {
                  setShowClose(!showClose);
                  setSliderOpen2(true);
                }}
                style={{ color: "#307BF6", marginLeft: "3px" }}
              >
                View More
              </Link>
            </>
          ) : isModified ? (
            <>
              {loanData?.reAmortizationRequestDetails?.modificationType == 1
                ? "Reamortize"
                : "Refinance"}{" "}
              request is pending approval for the{" "}
              {loanData?.loanType ?? "General purpose"} -{" "}
              {loanData?.loanIdentifier ?? "L001"}. Transaction fee of{" "}
              {usCurrency(
                loanData?.reAmortizationRequestDetails?.modificationFee
              )}{" "}
              applicable.
            </>
          ) : null}
        </p>
      </div>
    )
  );
};
export default LoanDisclaimer;
